import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class TableSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'table');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.backgroundColorField('background.color', ['content']),
            this.backgroundColorField('alternate.background.color', ['table', 'content']),
            this.borderColorField('border.color', ['main', 'content']),
            this.sizeNumberField('cell.padding'),
            this.sizeNumberField('cell.border.width', 'px'),
            this.sizeNumberField('row.border.width', 'px'),

            this.sizeNumberField('header.font.size'),
            this.fontWeightField('header.font.weight', ['main', 'content']),
            this.fontTransformField('header.font.transform'),
            this.fontColorComboField('header.font.color', ['main', 'content', 'header']),

            this.backgroundColorField('header.background.color', ['table', 'header', 'content']), 

            
            this.fontColorComboField('active.font.color', ['main', 'content', 'header'], this.preset('active-font-color', 'main')),
            this.backgroundColorField('active.background.color', ['table', 'content'], this.preset('active-background-color', 'main')),
            this.sizeNumberField('active.border.radius', 'px'),
            this.sizeNumberField('active.margin.x'),
            this.fontColorComboField('hover.font.color', ['main', 'content', 'header'], this.preset('hover-font-color', 'main')),
            this.backgroundColorField('hover.background.color', ['table', 'content'], this.preset('hover-background-color', 'main')),

        ];
    }

}
